import React from "react";

export function CheckIcon({
  size = 24,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.3937 2.40625L5.93366 9.87292L2.55366 6.67292L0.666992 8.55958L5.98033 13.5929L15.3337 4.23958L13.3937 2.40625Z"
        fill="#252525"
      />
    </svg>
  );
}
